import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { CountdownTimer } from './ui/CountdownTimer';
export const PricingSection: React.FC = () => {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'elite'>('elite');
  const checkoutUrls = {
    standard: 'https://pagos.recursosfitness.shop/cart/44010877517921:1',
    elite: 'https://pagos.recursosfitness.shop/cart/44010876436577:1'
  };
  return <section id="pricing" className="py-10 md:py-20 bg-gray-50 relative overflow-hidden" data-id="element-347">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-348">
        <CountdownTimer data-id="element-349" />

        <div className="text-center mb-8 md:mb-12 mt-6 md:mt-10" data-id="element-350">
          <h2 className="text-3xl md:text-5xl font-bold font-serif text-gray-900 mb-3" data-id="element-351">
            Elegí tu{' '}
            <span className="text-primary" data-id="element-352">Profes de Telas Resuelto</span>:
          </h2>
          <p className="text-base md:text-lg text-gray-600 font-medium" data-id="element-353">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="flex flex-col gap-4 md:gap-6 mb-8" data-id="element-354">
          {/* Standard Plan */}
          <div onClick={() => setSelectedPlan('standard')} className={`relative rounded-2xl p-4 md:p-6 cursor-pointer transition-all duration-300 border-2 ${selectedPlan === 'standard' ? 'border-primary bg-white shadow-md' : 'border-gray-200 bg-white/60 hover:bg-white'}`} data-id="element-355">
            <div className="flex items-center gap-3 md:gap-4" data-id="element-356">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selectedPlan === 'standard' ? 'border-primary' : 'border-gray-300'}`} data-id="element-357">
                {selectedPlan === 'standard' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-primary rounded-full" data-id="element-358" />}
              </div>

              <div className="flex-grow" data-id="element-359">
                <div className="flex items-center gap-2 mb-1" data-id="element-360">
                  <span className="text-lg md:text-xl" data-id="element-361">📘</span>
                  <h3 className="font-bold text-gray-900 text-sm md:text-lg font-serif" data-id="element-362">
                    PROFES DE TELAS RESUELTO
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-gray-500" data-id="element-363">
                  6 Tomos + 6 Bonos
                </p>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-364">
                <div className="text-xs md:text-sm text-gray-400 line-through mb-0.5" data-id="element-365">
                  $34.990
                </div>
                <div className="text-xl md:text-3xl font-bold text-gray-900" data-id="element-366">
                  $19.990
                </div>
              </div>
            </div>
          </div>

          {/* Elite Plan */}
          <div onClick={() => setSelectedPlan('elite')} className={`relative rounded-2xl p-4 md:p-6 cursor-pointer transition-all duration-300 border-2 mt-2 ${selectedPlan === 'elite' ? 'border-accent bg-white shadow-md' : 'border-gray-200 bg-white/60 hover:bg-white'}`} data-id="element-367">
            {/* Badges */}
            <div className="absolute -top-3 left-4 md:left-6 flex gap-2 z-10" data-id="element-368">
              <span className="bg-yellow-400 text-yellow-900 text-[10px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full flex items-center gap-1 shadow-sm" data-id="element-369">
                🔥 MÁS ELEGIDO
              </span>
              <span className="bg-primary text-white text-[10px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full shadow-sm" data-id="element-370">
                AHORRÁS $16.000
              </span>
            </div>

            <div className="flex items-start md:items-center gap-3 md:gap-4 pt-2 md:pt-0" data-id="element-371">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center mt-1 md:mt-0 transition-colors ${selectedPlan === 'elite' ? 'border-accent' : 'border-gray-300'}`} data-id="element-372">
                {selectedPlan === 'elite' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-accent rounded-full" data-id="element-373" />}
              </div>

              <div className="flex-grow" data-id="element-374">
                <div className="flex items-center gap-2 mb-1" data-id="element-375">
                  <span className="text-lg md:text-xl" data-id="element-376">🏆</span>
                  <h3 className="font-bold text-gray-900 text-sm md:text-lg font-serif leading-tight" data-id="element-377">
                    PROFES DE TELAS RESUELTO + PACK ÉLITE™
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-gray-500 leading-relaxed" data-id="element-378">
                  6 Tomos + 6 Bonos + Kit Emprendedora Fit + Programa Anual 12
                  Meses
                </p>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-379">
                <div className="text-xs md:text-sm text-gray-400 line-through mb-0.5" data-id="element-380">
                  $43.990
                </div>
                <div className="text-xl md:text-3xl font-bold text-accent" data-id="element-381">
                  $27.990
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <motion.a href={checkoutUrls[selectedPlan]} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full bg-accent hover:bg-accent-hover text-white font-bold py-4 md:py-5 px-6 rounded-xl text-center text-sm md:text-lg shadow-lg flex justify-center items-center gap-2 transition-colors" data-id="element-382">
          {selectedPlan === 'standard' ? '→ SÍ, QUIERO EL PROFES DE TELAS RESUELTO' : '→ SÍ, QUIERO EL PACK COMPLETO CON TODO'}
        </motion.a>

        {/* Testimonial Quote */}
        <p className="text-center text-xs md:text-sm text-gray-500 italic mt-6 mb-8 px-4" data-id="element-383">
          "La más elegida por instructoras que quieren enseñar con seguridad
          total y verse como las profesionales que realmente son"
        </p>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm text-gray-500 font-medium" data-id="element-384">
          <div className="flex items-center gap-1.5" data-id="element-385">
            <Lock size={16} className="text-gray-400" data-id="element-386" />
            <span data-id="element-387">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-388">
            <Zap size={16} className="text-yellow-500" data-id="element-389" />
            <span data-id="element-390">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-391">
            <ShieldCheck size={16} className="text-green-500" data-id="element-392" />
            <span data-id="element-393">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-394">
            <CreditCard size={16} className="text-blue-500" data-id="element-395" />
            <span data-id="element-396">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
};